/*
 * 国内实名认证相关内容
 * */
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Modal } from 'antd';
import { QRCodeCanvas } from 'qrcode.react';
import WEBIM from '../../../../../store/WebNim';
const Domestic = ({ cert, onCancel }) => {
  const base = useSelector((store) => store);
  const [isShowQrCode, setIsShowQrCode] = useState(false);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (cert?.certOperateType == 0) {
      // 防沉迷
      WEBIM.events['OPEN_ADDICTION_VERIFIED'] &&
        WEBIM.events['OPEN_ADDICTION_VERIFIED']();
      onCancel && onCancel();
    } else {
      setIsShowQrCode(true);
    }
  }, [cert]);

  const hideQrModal = () => {
    setIsShowQrCode(false);
    onCancel && onCancel();
  };
  return (
    <Modal
      open={isShowQrCode}
      width={'400px'}
      className="daidai-modal-style has-top-border download-sing-up-modal"
      title="扫码下载"
      centered={true}
      keyboard={false}
      onCancel={hideQrModal}
      footer={null}
      maskClosable={false}
      zIndex={1009}
    >
      <div style={{ padding: '30px' }}>
        <p className="tip-text">使用带带APP完成人脸识别</p>
        <div className="download-qr">
          <QRCodeCanvas
            value={`${base?.rootConfig?.mobilePath}?channelId=${base?.rootConfig?.channelId}`}
            imageSettings={{
              src: `/assets/img/logo-100.png`,
              width: 52,
              height: 52,
            }}
            size={212}
            bgColor={'#FFFFFF'}
            fgColor={'#000000'}
            level="M"
          />
        </div>
      </div>
    </Modal>
  );
};
export default connect((store) => ({ base: store }))(Domestic);
